import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import '../../styles/event.css';
import '../../styles/money.css';
import { choose } from '../../utils/platform';
import { useBrief } from './useBrief';
import BriefDesktop from './Brief.desktop';
import BriefMobile from './Brief.mobile';

const BriefView = choose(BriefDesktop, BriefMobile);

function BriefInner({ event }) {
  const vm = useBrief(event);
  return <BriefView vm={vm} />;
}

// Brief Report — one sheet: persons per function, who invited how many, cards
// to order, and the money paid / still to pay. Admin-only (see useBrief).
export default function Brief() {
  return <RequireEvent>{(event) => <BriefInner event={event} />}</RequireEvent>;
}
